import { render, staticRenderFns } from "./EntityController.vue?vue&type=template&id=6036559a&lang=pug"
import script from "./EntityController.vue?vue&type=script&lang=js"
export * from "./EntityController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports